import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';
import { getRoute, ROUTE_ENUMS } from '../../helpers/routes';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTelemetry } from '../../hooks/useTelemetry';

const Branding = () => {
	const navigate = useNavigate();
	const { isAuthenticated } = useAuth();
	const { trackClick } = useTelemetry();

	const handleNavigate = () => {
		trackClick('branding-home', { isAuthenticated });
		if (isAuthenticated) {
			navigate(getRoute(ROUTE_ENUMS.DASHBOARD), { replace: true });
		} else {
			navigate(getRoute(ROUTE_ENUMS.ROOT), { replace: true });
		}
	};

	return (
		<Stack onClick={handleNavigate}>
			<Typography variant="h6" fontWeight="bold">
				Meistro
			</Typography>
		</Stack>
	);
};

Branding.propTypes = {};

export default Branding;
